/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateReportTemplateDto } from '../models/CreateReportTemplateDto';
import type { ReportTemplateResponse } from '../models/ReportTemplateResponse';
import type { TemplateVariableCategoryResponse } from '../models/TemplateVariableCategoryResponse';
import type { UpdateReportTemplateDto } from '../models/UpdateReportTemplateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ReportTemplatesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a report template
     * Creates a new XML-based PDF report template. The XML defines the structure and layout of generated PDFs. Only one template can be active at a time. Variables use {{path}} syntax for dynamic content.
     * @returns ReportTemplateResponse Template created successfully.
     * @throws ApiError
     */
    public reportTemplatesControllerCreate({
        requestBody,
    }: {
        requestBody: CreateReportTemplateDto,
    }): CancelablePromise<ReportTemplateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/report-templates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid XML content.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * List all report templates
     * Returns all report templates ordered by creation date.
     * @returns ReportTemplateResponse List of templates.
     * @throws ApiError
     */
    public reportTemplatesControllerFindAll(): CancelablePromise<Array<ReportTemplateResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/report-templates',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Get the active report template
     * Returns the currently active template used for PDF generation. Returns 404 if no template is active.
     * @returns ReportTemplateResponse Active template found.
     * @throws ApiError
     */
    public reportTemplatesControllerFindActive(): CancelablePromise<ReportTemplateResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/report-templates/active',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `No active template found.`,
            },
        });
    }
    /**
     * List available template variables
     * Returns all variables available for use in XML templates, grouped by category. Use {{variable.path}} syntax in XML to insert dynamic values.
     * @returns TemplateVariableCategoryResponse Variables grouped by category.
     * @throws ApiError
     */
    public reportTemplatesControllerGetVariables(): CancelablePromise<Array<TemplateVariableCategoryResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/report-templates/variables',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * Get a report template by ID
     * Returns a single report template with its XML content.
     * @returns ReportTemplateResponse Template found.
     * @throws ApiError
     */
    public reportTemplatesControllerFindOne({
        id,
    }: {
        /**
         * Template unique identifier
         */
        id: string,
    }): CancelablePromise<ReportTemplateResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/report-templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Template not found.`,
            },
        });
    }
    /**
     * Update a report template
     * Updates a report template. If xmlContent is provided, it will be validated. If isActive is set to true, other templates will be deactivated.
     * @returns ReportTemplateResponse Template updated.
     * @throws ApiError
     */
    public reportTemplatesControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Template unique identifier
         */
        id: string,
        requestBody: UpdateReportTemplateDto,
    }): CancelablePromise<ReportTemplateResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/report-templates/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid XML content.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Template not found.`,
            },
        });
    }
    /**
     * Delete a report template
     * Permanently deletes a report template.
     * @returns any Template deleted.
     * @throws ApiError
     */
    public reportTemplatesControllerRemove({
        id,
    }: {
        /**
         * Template unique identifier
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/report-templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Template not found.`,
            },
        });
    }
    /**
     * Activate a report template
     * Sets the specified template as active and deactivates all others. The active template is used for PDF generation on new reports.
     * @returns ReportTemplateResponse Template activated.
     * @throws ApiError
     */
    public reportTemplatesControllerActivate({
        id,
    }: {
        /**
         * Template unique identifier
         */
        id: string,
    }): CancelablePromise<ReportTemplateResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/report-templates/{id}/activate',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Template not found.`,
            },
        });
    }
    /**
     * Preview a template as PDF
     * Generates a sample PDF using the template with mock data. Returns the PDF as a binary stream.
     * @returns any PDF preview generated.
     * @throws ApiError
     */
    public reportTemplatesControllerPreview({
        id,
    }: {
        /**
         * Template unique identifier
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/report-templates/{id}/preview',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid XML.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Template not found.`,
            },
        });
    }
    /**
     * Preview XML content as PDF
     * Generates a sample PDF from raw XML content without saving. Useful for live template editing.
     * @returns any PDF preview generated.
     * @throws ApiError
     */
    public reportTemplatesControllerPreviewXml({
        requestBody,
    }: {
        requestBody: {
            /**
             * XML template content
             */
            xmlContent: string;
        },
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/report-templates/preview-xml',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid XML.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
}
